import { ModuleConfig } from '@/core/module';
import { groupRoutes } from './routes';
import { useGroupStore } from './stores/group-store';

export const UserGroupModule: ModuleConfig = {
    name: 'user-group',
    routes: groupRoutes,
    stores: {
        group: useGroupStore
    },
    initialize: () => {
        console.log('User Group module initialized');
    }
};